import React from 'react'
import AddUser from './AddUser'
import EditUser from './EditUser'
import UserNewPassword from './UserNewPassword'
import UserListPage from './UserListPage'
import VendorUserListPage from './VendorUserListPage'

const userRoutes = [
  {
    breadcrumb: 'New Password',
    path: 'newPassword',
    element: <UserNewPassword />,
  },
]

export const adminUserRoutes = [
  {
    breadcrumb: 'Users',
    path: '',
    element: <UserListPage />,
    children: [],
  },
  {
    breadcrumb: 'Vendor Users',
    path: 'vendors',
    element: <VendorUserListPage />,
    children: [],
  },
  {
    breadcrumb: 'Create',
    path: 'create',
    element: <AddUser />,
  },
  {
    breadcrumb: 'Detail',
    path: ':id',
    element: <EditUser />,
  },
]

export default userRoutes
